/* eslint-disable */
import qualityAnalyticsServices from '@/Services/Analytics Services/qualityAnalytics.services';
import { useAnalysisStore } from '../AssetAnalysisStore';
import masterMenuServices from '@/Services/ProductSpecificationParamServices/productMasterMenu.services';
import {
	getAnalysisType,
	getGroupingType,
	metricsToCardData,
} from './filterDeserializer';
import { notificationServices } from '@/Services';
import moment from 'moment';
import fetchStatisticalAnalysisGraph from '@/Services/Analytics Services/statisticalAnalysisServices';
import { assetAnalyticsServices } from '@/Services/Analytics Services/assetAnalytics.services';
// Initialize listeners for state changes

const fetchInitialData = async () => {
	const state = useAnalysisStore.getState();
	state.setLoading(true);
	const [dataResponse] = await Promise.all([
		fetchAppropriateData(),
		// masterMenuServices.productMasterMenuList(),
	]);
	// const response = menuResponse; // Maintain the response variable for the following code
	// // Simulate a 10-second delay for development/testing purposes
	// // await new Promise(resolve => setTimeout(resolve, 10000));
	// if (response?.statusCode === 200) {
	// 	const data = response?.data;
	// 	const newData = data
	// 		.map((item) => ({
	// 			key: item?.id,
	// 			label: item?.name,
	// 			inputType: item?.inputType,
	// 		}))
	// 		?.filter((item) => ['number', 'decimal'].includes(item?.inputType));
	// 	state.setAnalysisParameters(newData);
	// } else {
	// 	notificationServices.generateNotification({
	// 		type: 'error',
	// 		message: response?.message || 'Error fetching Asset master menu',
	// 	});
	// }
	state.setLoading(false);
};


const initializeStateChangeListeners = () => {
	fetchInitialData();
	const unSubs = [];
	changeEventOnKeys.forEach((key) => {
		const unSub = useAnalysisStore.subscribe(
			(state) => state[key],
			(current, previous) => {
				keyChangeFunction(key, current, previous);
			}
		);
		unSubs.push(unSub);
	});
	return () => unSubs.forEach((unSub) => unSub());
};

// Function to fetch appropriate data based on active analysis tab
const fetchAppropriateData = async () => {
	const state = useAnalysisStore.getState();
	const activeAnalysisTab = state?.activeAnalysisTab;
	const activeTab = state?.activeTab;
	try {
		const filters = buildFiltersFromState();
		state?.setLoading(true);
		switch (activeAnalysisTab) {
			case 'quantitative':
				let response = {};
				response = await assetAnalyticsServices.fetchAssetAnalysis({
					req: {
						data: { failureAnalysis: {}, ...filters },
					},
				});

				if (response?.statusCode === 200) {
					state?.setAnalysisChartData(response?.data);
				}
				break;
			default:
				console.warn(`Unknown analysis tab: ${activeAnalysisTab}`);
		}
	} catch (error) {
		console.error(`Error fetching data for ${activeAnalysisTab}:`, error);
	} finally {
		state?.setLoading(false);
	}
};

const buildFiltersFromState = () => {
	const state = useAnalysisStore.getState();

	const analysisTypeObjFilters = getAnalysisType(
		state?.activeAnalysisTab,
		state
	);
	const dateRangeAndGrouping = getGroupingType(
		state?.activeConfigType,
		state
	);
	const grouping = {};
	if (state?.activeAnalysisTab) {
		grouping.active = true;
	}

	// Extract date details from dateInfo
	const filterState = {
		...dateRangeAndGrouping,
		...analysisTypeObjFilters,
	};

	return filterState;
};

const changeEventOnKeys = [
	// 'activeTab',
	'activeAnalysisTab',
	'activeQCType',
	'activeConfigType',
	'activeTimeRangeDropdown',
	'dateRangeObj',
	'dateInfo',
	// 'selectedAnalysisParameter',
	// 'selectedAssetParameterProduct',
	'activeAssetWiseDropdown',
	'activeGeographyWiseDropdown',
	// 'triggerChartUpdateApiCall',
	// 'cardData',
];

const keyChangeFunction = (key, current, previous) => {
	console.log(`${key} changed: `, current, ` (previous: `, previous, ')');
	// because activeTimeRangeDropdown useEffect causes dateInfo to be changed
	// const state = useAnalysisStore.getState();
	
	fetchAppropriateData();
};

export default {
	initializeStateChangeListeners,
};
